<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'admin.settlement_management' | transloco }}
                </div>
                <div class="card-body">
                    <div class="form-group row">
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.event_date' | transloco }}</label>
                        <div class="col-md-2">
                            <wj-combo-box style="width:100%;" [itemsSource]="optionAuction" [(ngModel)]="auctionDate" (selectedIndexChanged)="onAuctionChanged()" [isRequired]="true"></wj-combo-box>
                        </div>
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.venue' | transloco }}</label>
                        <div class="col-md-2">
                            <wj-combo-box style="width:100%;" [itemsSource]="optionPlace" [(ngModel)]="auctionPlace" (selectedIndexChanged)="onAuctionChanged()" [isRequired]="true"></wj-combo-box>
                        </div>
                        <div class="col-md-4">
                            <button (click)="createInvoice()" class="btn btn-success btn-block">{{ 'admin.regenerate' | transloco }}</button>
                        </div>
                    </div>
                    <wj-tab-panel [selectedIndex]="0">
                        <wj-tab>
                            <a>{{ 'admin.invoice_data' | transloco }}</a>
                            <div class="card">
                                <div class="card-header">
                                    {{ 'admin.invoice_data' | transloco }}
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <wj-flex-grid #invoiceGrid [isReadOnly]="false" [selectionMode]="'Row'" style="height:500px" [itemsSource]="invoices">
                                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                                <wj-flex-grid-column [binding]="'auctionDate'" [header]="'admin.event_date' | transloco" [dataType]="'Date'" [format]="'yyyy/MM/dd'" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'auctionPlace'" [header]="'admin.venue' | transloco" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'customerName'" [header]="'admin.customer_name' | transloco" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'total'" [header]="'admin.total_amount' | transloco" [dataType]="'Number'" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'status'" [header]="'admin.status' | transloco" [width]="100"></wj-flex-grid-column>
                                            </wj-flex-grid>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </wj-tab>
                        <wj-tab>
                            <a>{{ 'admin.summary' | transloco }}</a>
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <wj-pivot-grid #pivotGrid [itemsSource]="pivot"></wj-pivot-grid>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </wj-tab>
                        <wj-tab>
                            <a>{{ 'admin.data_by_customer' | transloco }}</a>
                            <div class="card">
                                <div class="card-header">
                                    {{ 'admin.data_by_customer' | transloco }}
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <wj-flex-grid #itemGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="invoiceLines">
                                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                                <wj-flex-grid-column [binding]="'id'" [header]="'admin.item_id' | transloco" [dataType]="'Number'" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'eventDate'" [header]="'admin.event_date' | transloco" [dataType]="'Date'" [format]="'yyyy/MM/dd'" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'seller.memberName'" [header]="'admin.seller' | transloco" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'sellerCharge'" [header]="'admin.buyer_fee_rate' | transloco" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'place'" [header]="'admin.venue' | transloco" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'lane'" [header]="'admin.lane' | transloco" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'category'" [header]="'admin.item_category' | transloco" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'auctionResult'" [header]="'admin.auction_result' | transloco" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'name'" [header]="'admin.item_name' | transloco" [width]="150"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'description'" [header]="'admin.item_description' | transloco" [width]="200"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'quantity'" [header]="'admin.quantity' | transloco" [dataType]="'Number'" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'unit'" [header]="'admin.unit' | transloco" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'buyer.memberName'" [header]="'admin.buyer' | transloco" [width]="100"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'buyerCharge'" [header]="'admin.buyer_fee_rate' | transloco" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'auctionPrice'" [header]="'admin.winning_price' | transloco" [dataType]="'Number'" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'minimumPrice'" [header]="'admin.minimum_price' | transloco" [dataType]="'Number'" [width]="80"></wj-flex-grid-column>
                                                <wj-flex-grid-column [binding]="'startPrice'" [header]="'admin.start_price' | transloco" [dataType]="'Number'" [width]="80"></wj-flex-grid-column>
                                            </wj-flex-grid>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </wj-tab>
                        <wj-tab>
                            <a>{{ 'admin.trade_ledger' | transloco }}</a>
                            <div class="card">
                                <div class="card-body">
                                    <div id="viewerContent"></div>
                                </div>
                            </div>
                        </wj-tab>
                    </wj-tab-panel>
                </div>
            </div>
        </div>
    </div>
</div>

